import React from 'react'
import { Row, Col } from 'react-bootstrap'
import ProjectRow from './project-row'
import './index.styl'


class Component extends React.Component {
  setProject (project) {
    const { actions, type } = this.props
    actions.setProject(project.id)
    actions.resetSegments()
    actions.push(type === 'segments' ? '/segments' : '/headers')
  }

  render () {
    const { projects, fetched, fetching, actions, auth, project, me, type } = this.props
    const rows = []

    if (typeof me !== 'object' || me === null) {
      return (
        <main>
          <section className="container align-center">
            <h1 className="margin-top">Fout...</h1>
            <pre>{JSON.stringify(me, null, 2)}</pre>
          </section>
        </main>
      )
    }

    if (fetched === false && fetching === false) {
      // Fetch the list of types...
      actions.fetchProjects(auth.token)

      return (
        <main>
          <section className="container align-center">
            <h1 className="margin-top">Momentje...</h1>
          </section>
        </main>
      )
    }

    if (fetched === true && fetching === false && projects.length === 0) {
      return (
        <main>
          <section className="container align-center">
            <h1 className="margin-top">Geen projecten gevonden</h1>
          </section>
        </main>
      )
    }

    if (fetched === true && fetching === false && projects.length > 0) {
      projects
      .filter(p => {
        if (me.accessLevel >= 100 || me.role === 'superuser') {
          if (p.id !== '58f0ab966bf0963301ba5a00' && type === 'credits_transactions') {
            return false
          }

          if ((type === 'campaign_giveaway_stats' || type === 'campaign_giveaway_submissions') && p.id !== '5a2191f74be05b2901f5d212') {
            return false
          }

          return true
        }

        if (p.id !== ((typeof me.project === 'object' && me.project !== null) ? me.project.id : me.project)) {
          return false
        }

        return true
      })
      .forEach(p => {
        rows.push(<ProjectRow project={p} key={p.id} active={p.id === project} click={() => { this.setProject(p) }} />)
      })
    }

    return (
      <main>
        <section className="container">
          <Row>
            <Col xs={12}>
              {rows}
            </Col>
          </Row>
        </section>
      </main>
    )
  }
}

export default Component



// WEBPACK FOOTER //
// ./components/Projects/index.js